import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import './App.css';
import './star.css';
import IndexRouters from './routers/IndexRouters';
import { DarkModeProvider } from './context/darkModeContext';
import Loader from './tools/Loader';
import { useDispatch } from 'react-redux';
import { Profilehandler } from './redux/Slice/getprofile';
import {
  applySuperadminFavicon,
  getStoredSuperadminBranding,
  persistSuperadminBranding,
} from './utils/superadminBranding';

// Lazy loa d the SuperAdmin component ok

const SuperAdmin = lazy(() => import('./routers/SuperAdmin'));

function App() {
  const auth = sessionStorage.getItem('token');
  const role = sessionStorage.getItem('userdata');
  const dispatch = useDispatch();
  // Backend sends role as "Super Admin" or user name; show dashboard for admin or super admin
  const isSuperAdmin = role && (role.toLowerCase() === 'admin' || role.toLowerCase() === 'super admin');


  useEffect(() => {
    // Handle magic link login (only when token/role come from URL)
    const queryParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = queryParams.get('token');
    const roleFromUrl = queryParams.get('role');
    if (tokenFromUrl && roleFromUrl) {
      sessionStorage.setItem('token', tokenFromUrl);
      sessionStorage.setItem('userdata', roleFromUrl);
      window.location.replace('/');
    }
  }, []);

  useEffect(() => {
    const cachedBranding = getStoredSuperadminBranding();
    applySuperadminFavicon(cachedBranding.favicon_url);
  }, []);

  useEffect(() => {
    if (!auth || !isSuperAdmin) return;

    dispatch(Profilehandler())
      .unwrap()
      .then((profile) => {
        const branding = {
          name: profile?.personal_information?.name || 'LMS',
          ...profile?.branding,
        };
        persistSuperadminBranding(branding);
      })
      .catch(() => {
        // Keep cached branding if profile fetch fails.
      });
  }, [auth, isSuperAdmin, dispatch]);

  return (
    <DarkModeProvider>
      <Router>
        {(!auth || auth === 'null') ? (
          <IndexRouters />
        ) : isSuperAdmin ? (
          <Suspense fallback={<Loader />}>
            <SuperAdmin />
          </Suspense>
        ) : (
          <IndexRouters />
        )}
      </Router>
    </DarkModeProvider>
  );
}

export default App;
